import { Component, EventEmitter, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { RouterLinkType } from '@core/common.types';
import { navigateRouterLink } from '@platform/shared/utilities/navigate.util';

@Component({
  selector: 'app-button-icon-upload',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, RouterModule],
  template: `
    <button mat-icon-button (click)="onClick()" [matTooltip]="tooltip ?? ''" matTooltipPosition="above">
      <mat-icon svgIcon="upload" color="primary"></mat-icon>
    </button>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ButtonIconUploadComponent {
  @Input() tooltip?: string;
  click = new EventEmitter();
  routerLink: RouterLinkType;
  router = inject(Router);

  onClick() {
    if (this.routerLink) {
      navigateRouterLink(this.router, this.routerLink);
    } else {
      this.click.emit();
    }
  }
}
